import { z } from 'zod';
import { listResponse } from '../../utils/listResponse';
import { schemaSchema } from '../models/schema.schema';
import { schemaListQuerySchema } from './list.schema';

export type SchemaListQuery = {
  id?: number;
  name?: string;
};

export const list = (query: SchemaListQuery = {}) => {
  return {
    endpoint: `/schemas`,
    method: 'GET',
    responseSchema: listResponse(schemaSchema),
    query: { ...query, includeTotal: true },
    querySchema: schemaListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
